import { ICellRendererParams } from "ag-grid-community";
import { Flex, Tag, Text } from "@jsq/ds/core";
import { type FatcaPositionRow } from "./gridConfig";
import * as styles from "./styles_vanilla.css";

const PositionNameRenderer = (params: ICellRendererParams<FatcaPositionRow>) => {
  const { data } = params;
  if (!data) return null;

  return (
    <Flex alignItems="center" gap={8} className={styles.positionNameCell}>
      <Text variant="regular-md" className={styles.positionNameText}>
        {data.positionName}
      </Text>
      {data.isCurrentCase && <Tag label="Current case" className={styles.currentCaseTag} />}
    </Flex>
  );
};

export default PositionNameRenderer;
